import React from "react"

import { AppAntSwitch } from "@components"
import { showFeatures } from "@signals"


export default function AppCommonFiltersShowFeatures({ ...props }) {
	return <AppAntSwitch
		falseText="Hide features"
		trueText="Show features"
		checked={showFeatures.value}
		onChange={newValue => showFeatures.value = newValue.target.checked}
		{...props}
	/>
}